module.exports = __webpack_public_path__ + "img/Penny-Hat-02.2182cf6c.jpg";